import { getDocsSectionsArr } from "@/config/docs-config";
import { ArrowRight, CodeXml, User } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

const DOCS_SECTIONS_ARR = getDocsSectionsArr()

const DocsIndexPage = () => {
  const navigate = useNavigate();

  return (
    <div className="lg:mt-10 text-glass-foreground flex flex-col gap-4">
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <CodeXml />
          <p className="text-glass-foreground font-bold text-xs uppercase"> Developer Hub</p>
        </div>
        <h1 className="text-[36px] font-extrabold leading-[42px] tracking-">Loopp API Documentation</h1>
        <p className="text-glass-foreground/70 text-sm leading-relaxed max-w-md md:font-medium">
          Welcome to the official Loopp API documentation. Explore how to manage users and meetings details, summaries
          and audio.
        </p>
      </div>

      <div className="flex flex-col gap-3">
        <span className="text-lg font-semibold">Quick Links</span>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {DOCS_SECTIONS_ARR.map((section) => {
            const Icon = section.icon || User;

            return (
              <button
                key={section.id}
                onClick={() => navigate(`/docs/${section.url}`)}
                className="glass-surface dark:border-white/20! cursor-pointer p-4 rounded-xl text-left flex flex-col gap-3 hover:bg-black/5! transition-colors group"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="p-2 rounded-lg bg-accent/15">
                      <Icon className="text-accent h-4 w-4" />
                    </div>
                    <span className="font-semibold text-lg">{section.label}</span>
                  </div>
                  <ArrowRight className="h-4 w-4 text-black/30 group-hover:text-accent group-hover:translate-x-0.5 transition-all" />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-black/40 dark:text-white/60 text-xs leading-relaxed">{section.description}</span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DocsIndexPage;
